import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import './index.scss'

const AddExecutiveOfficer = ({onAddExecutiveOfficer}) => {
  const [email, setEmail] = useState('')

  const updateEmail = (evt) => setEmail(evt.target.value)

  const addOfficer = () => {
    onAddExecutiveOfficer(email)
    setEmail('')
  }

  const keyDown = (evt) => {
    if (evt.nativeEvent.key === 'Enter') {
      addOfficer()
    }
  }

  return (
    <div className="add-executive-officer">
      <Heading level={3}>Legg til saksbehandler</Heading>
      <Input
        value={email}
        onChange={updateEmail}
        placeholder="E-post"
        onKeyDown={keyDown}
      />
      <Button
        type="action"
        onClick={addOfficer}
      >
        Legg til
      </Button>
    </div>
  )
}

AddExecutiveOfficer.propTypes = {
  onAddExecutiveOfficer: PropTypes.func.isRequired,
}

export default AddExecutiveOfficer
